import { createEvent, sample, combine } from 'effector';
import { createForm } from 'effector-forms';
import rules from 'src/effector/forms/rules';
import { getErrors } from 'src/effector/forms/helpers';
import * as api from 'src/logic/api';

const next = createEvent();
const submit = createEvent();

const form = createForm({
  fields: {
    phone: {
      init: '',
      rules: [rules.required(), rules.minLength(10)],
    },
    totalAnnualRevenue: {
      init: '',
      rules: [rules.required()],
    },
    businessType: {
      init: '',
      rules: [rules.required()],
    },
    entityType: {
      init: '',
      rules: [rules.required()],
    },
    industry: {
      init: '',
      rules: [rules.required()],
    },
    accepts_marketing: {
      init: false,
    },
  },
});

sample({
  clock: sample({
    clock: submit,
    fn: () => console.log('proprietor1submit'),
    target: form.validate,
  }),
  source: form.$isValid,
  filter: isValid => {
    console.log('proprietor1submit isValid', form);
    return isValid;
  },
  target: next,
});

const $formErrors = getErrors(Object.keys(form.fields), form);
const $isValidForm = form.$isValid.map(isValid => isValid);

export const stores = {
  form,
  $formErrors,
  $isValidForm,
};

export const store = combine(stores);

export const actions = {
  submit,
  next,
};
